import { useEffect, useState } from 'react'
import {
  Layout as AntLayout,
  Row,
  Col,
  Card,
  Form,
  Input,
  InputNumber,
  Select,
  DatePicker,
  Upload,
  Button,
  Modal,
  Tag,
  message
} from 'antd'
import {
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  ArrowUpOutlined,
  ArrowDownOutlined,
  InboxOutlined
} from '@ant-design/icons'
import dayjs from 'dayjs'
import LayoutPage from '../../layouts/Main'
import './MarketingEspeciales.scss'

const { Content } = AntLayout
const { Option } = Select
const { confirm } = Modal
const { Dragger } = Upload

const OFFERS_STORAGE_KEY = 'marketing_specials_offers'

const initialOffers = [
  {
    id: 1,
    title: 'Laptop HP Pavilion 15',
    description: 'Laptop potente para tareas diarias y oficina.',
    category: 'Electrónica',
    tag: 'Ofertas',
    discountPct: 25,
    originalPrice: 15999,
    price: 11999,
    order: 1,
    start: '2026-02-09',
    end: '2026-02-19',
    imageUrl: 'https://images.unsplash.com/photo-1517336714731-489689fd1ca8?auto=format&fit=crop&w=800&q=60'
  },
  {
    id: 2,
    title: 'Smart TV Samsung 55"',
    description: 'Smart TV 4K con apps integradas.',
    category: 'Electronica',
    tag: 'Ofertas',
    discountPct: 30,
    originalPrice: 12999,
    price: 8999,
    order: 2,
    start: '2026-02-11',
    end: '2026-02-27',
    imageUrl: 'https://images.unsplash.com/photo-1509281373149-e957c6296406?auto=format&fit=crop&w=800&q=60'
  },
  {
    id: 3,
    title: 'Auriculares Sony WH-1000XM5',
    description: 'Cancelación de ruido premium.',
    category: 'Audio',
    tag: 'Productos Top',
    groupId: 100,
    discountPct: 30,
    originalPrice: 6999,
    price: 4899,
    order: 1,
    start: '2026-01-31',
    end: '2026-02-14',
    imageUrl: 'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?auto=format&fit=crop&w=800&q=60'
  },
  {
    id: 4,
    title: 'Monitor 27" 4K',
    description: 'Panel IPS con gran nitidez.',
    category: 'Electronica',
    tag: 'Productos Top',
    groupId: 100,
    discountPct: 18,
    originalPrice: 10999,
    price: 8999,
    order: 2,
    start: '2026-02-01',
    end: '2026-02-28',
    imageUrl: 'https://images.unsplash.com/photo-1517336714731-489689fd1ca8?auto=format&fit=crop&w=800&q=60'
  },
  {
    id: 5,
    title: 'Teclado mecánico RGB',
    description: 'Switches tactiles para productividad.',
    category: 'Accesorios',
    tag: 'Productos Top',
    groupId: 100,
    discountPct: 12,
    originalPrice: 1999,
    price: 1749,
    order: 3,
    start: '2026-02-01',
    end: '2026-02-28',
    imageUrl: 'https://images.unsplash.com/photo-1517430816045-df4b7de11d1d?auto=format&fit=crop&w=800&q=60'
  },
  {
    id: 6,
    title: 'iPhone 15 Pro Max',
    description: 'El smartphone mas potente del momento.',
    category: 'Smartphones',
    tag: 'Especiales',
    discountPct: 16,
    originalPrice: 29999,
    price: 24999,
    order: 1,
    start: '2026-02-01',
    end: '2026-02-28',
    imageUrl: 'https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?auto=format&fit=crop&w=800&q=60'
  }
]

const formatCurrency = (value) =>
  value?.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })

const formatDates = (start, end) => {
  if (!start || !end) return 'Sin vigencia'
  return `${dayjs(start).format('DD/MM/YYYY')} - ${dayjs(end).format('DD/MM/YYYY')}`
}

const getTagColor = (tag) => {
  if (tag === 'Productos Top') return 'green'
  if (tag === 'Especiales') return 'blue'
  return 'green'
}

const categories = ['Electronica', 'Audio', 'Smartphones', 'Accesorios', 'Hogar']

const normalizeUpload = (e) => (Array.isArray(e) ? e : e?.fileList)

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = reject
  })

export default function MarketingEspeciales() {
  const [form] = Form.useForm()
  const [offers, setOffers] = useState(() => {
    try {
      const stored = localStorage.getItem(OFFERS_STORAGE_KEY)
      if (stored) {
        const parsed = JSON.parse(stored)
        if (Array.isArray(parsed)) return parsed
      }
    } catch (error) {
      return initialOffers
    }
    return initialOffers
  })
  const [modalOpen, setModalOpen] = useState(false)
  const [saving, setSaving] = useState(false)
  const [editing, setEditing] = useState(null)
  const [editingGroupId, setEditingGroupId] = useState(null)

  useEffect(() => {
    try {
      localStorage.setItem(OFFERS_STORAGE_KEY, JSON.stringify(offers))
    } catch (error) {
      // ignore storage write errors
    }
  }, [offers])

  const sectionValue = Form.useWatch('section', form)
  const modalSubtitle = sectionValue === 'top3'
    ? 'Configuració  de Top 3 Productos Mas Vendidos'
    : 'Configuración de ofertas marketplace'

  const stats = {
    total: offers.length,
    ofertas: offers.filter((offer) => offer.tag === 'Ofertas').length,
    top: offers.filter((offer) => offer.tag === 'Productos Top').length,
    especiales: offers.filter((offer) => offer.tag === 'Especiales').length
  }

  const openNew = () => {
    setEditing(null)
    setEditingGroupId(null)
    form.resetFields()
    form.setFieldsValue({ section: 'offers' })
    setModalOpen(true)
  }

  const openEdit = (offer) => {
    const section = offer.tag === 'Especiales' ? 'specials' : offer.tag === 'Productos Top' ? 'top3' : 'offers'
    if (section === 'top3' && offer.groupId) {
      const groupItems = offers
        .filter((item) => item.groupId === offer.groupId)
        .sort((a, b) => a.order - b.order)
        .map((item) => ({
          title: item.title,
          description: item.description,
          category: item.category,
          discountPct: item.discountPct,
          originalPrice: item.originalPrice,
          price: item.price,
          start: item.start ? dayjs(item.start) : null,
          end: item.end ? dayjs(item.end) : null,
          image: item.imageUrl
            ? [{ uid: item.id, name: 'imagen', status: 'done', url: item.imageUrl }]
            : []
        }))
      setEditing(null)
      setEditingGroupId(offer.groupId)
      form.setFieldsValue({
        section,
        topProducts: groupItems
      })
    } else {
      setEditing(offer)
      setEditingGroupId(null)
      form.setFieldsValue({
        section,
        title: offer.title,
        description: offer.description,
        category: offer.category,
        discountPct: offer.discountPct,
        originalPrice: offer.originalPrice,
        price: offer.price,
        start: offer.start ? dayjs(offer.start) : null,
        end: offer.end ? dayjs(offer.end) : null,
        image: offer.imageUrl
          ? [{ uid: offer.id, name: 'imagen', status: 'done', url: offer.imageUrl }]
          : []
      })
    }
    setModalOpen(true)
  }

  const handleDelete = (offerId) => {
    confirm({
      title: 'Eliminar oferta',
      content: 'Esta accion no se puede deshacer.',
      okText: 'Eliminar',
      okType: 'danger',
      cancelText: 'Cancelar',
      centered: true,
      onOk: () => {
        setOffers((prev) => prev.filter((offer) => offer.id !== offerId))
        message.success('Oferta eliminada')
      }
    })
  }

  const onFinish = async (values) => {
    setSaving(true)
    const section = values.section

    if (section === 'top3') {
      const items = values.topProducts || []
      if (items.length !== 3) {
        message.error('Debes agregar 3 productos para el Top 3')
        setSaving(false)
        return
      }

      const mappedItems = await Promise.all(
        items.map(async (item, index) => {
          const imageFile = item.image?.[0]
          let imageUrl = imageFile?.url || ''
          if (imageFile?.originFileObj) {
            imageUrl = await getBase64(imageFile.originFileObj)
          }
          return {
            title: item.title?.trim(),
            description: item.description?.trim(),
            category: item.category,
            tag: 'Productos Top',
            discountPct: Number(item.discountPct),
            originalPrice: Number(item.originalPrice),
            price: Number(item.price),
            order: index + 1,
            start: item.start ? dayjs(item.start).format('YYYY-MM-DD') : null,
            end: item.end ? dayjs(item.end).format('YYYY-MM-DD') : null,
            imageUrl
          }
        })
      )

      setOffers((prev) => {
        const nextGroupId = editingGroupId || Math.max(0, ...prev.map((offer) => offer.groupId || 0)) + 1
        const nextIdStart = Math.max(0, ...prev.map((offer) => offer.id)) + 1
        const newItems = mappedItems.map((item, idx) => ({
          id: nextIdStart + idx,
          groupId: nextGroupId,
          ...item
        }))

        const cleaned = editingGroupId ? prev.filter((offer) => offer.groupId !== editingGroupId) : prev
        return [...cleaned, ...newItems]
      })

      message.success(editingGroupId ? 'Top 3 actualizado' : 'Top 3 creado')
      setSaving(false)
      setModalOpen(false)
      form.resetFields()
      setEditingGroupId(null)
      return
    }

    const imageFile = values.image?.[0]
    let imageUrl = imageFile?.url || ''
    if (imageFile?.originFileObj) {
      imageUrl = await getBase64(imageFile.originFileObj)
    }

    const tagLabel = section === 'specials' ? 'Especiales' : 'Ofertas'
    const currentOrders = offers
      .filter((offer) => offer.tag === tagLabel)
      .map((offer) => offer.order || 0)
    const nextOrder = currentOrders.length ? Math.max(...currentOrders) + 1 : 1

    const payload = {
      title: values.title?.trim(),
      description: values.description?.trim(),
      category: values.category?.trim(),
      tag: tagLabel,
      discountPct: Number(values.discountPct),
      originalPrice: Number(values.originalPrice),
      price: Number(values.price),
      order: editing?.order || nextOrder,
      start: values.start ? dayjs(values.start).format('YYYY-MM-DD') : null,
      end: values.end ? dayjs(values.end).format('YYYY-MM-DD') : null,
      imageUrl
    }

    setOffers((prev) => {
      if (editing) {
        return prev.map((offer) => (offer.id === editing.id ? { ...offer, ...payload } : offer))
      }
      const nextId = Math.max(0, ...prev.map((offer) => offer.id)) + 1
      return [...prev, { id: nextId, ...payload }]
    })

    message.success(editing ? 'Oferta actualizada' : 'Oferta creada')
    setSaving(false)
    setModalOpen(false)
    form.resetFields()
  }


  return (
    <LayoutPage>
      <Content className="marketing-specials">
        <Card className="marketing-specials-header" bordered={false}>
          <div className="marketing-specials-title">Administración de ofertas</div>
          <div className="marketing-specials-stats">
            <div className="marketing-specials-stat">
              <div className="marketing-specials-stat-value">{stats.total}</div>
              <div className="marketing-specials-stat-label">TOTAL</div>
            </div>
            <div className="marketing-specials-stat">
              <div className="marketing-specials-stat-value">{stats.ofertas}</div>
              <div className="marketing-specials-stat-label">OFERTAS</div>
            </div>
            <div className="marketing-specials-stat">
              <div className="marketing-specials-stat-value">{stats.top}</div>
              <div className="marketing-specials-stat-label">TOP</div>
            </div>
            <div className="marketing-specials-stat">
              <div className="marketing-specials-stat-value">{stats.especiales}</div>
              <div className="marketing-specials-stat-label">ESPECIALES</div>
            </div>
          </div>
        </Card>

        <Row gutter={[24, 24]} className="marketing-specials-grid">
          {offers.map((offer) => (
            <Col key={offer.id} xs={24} sm={12} lg={6}>
              <Card
                className="marketing-specials-card"
                cover={
                  <div className="marketing-specials-image">
                    <img src={offer.imageUrl} alt={offer.title} />
                    <Tag className="marketing-specials-tag" color={getTagColor(offer.tag)}>
                      {offer.tag}
                    </Tag>
                    <div className="marketing-specials-discount">-{offer.discountPct}%</div>
                  </div>
                }
                actions={[
                  <Button key="edit" type="text" icon={<EditOutlined />} onClick={() => openEdit(offer)} />,
                  <Button
                    key="delete"
                    type="text"
                    danger
                    icon={<DeleteOutlined />}
                    onClick={() => handleDelete(offer.id)}
                  />
                ]}
              >
                <div className="marketing-specials-category">{offer.category}</div>
                <div className="marketing-specials-name">{offer.title}</div>
                <div className="marketing-specials-prices">
                  <span className="marketing-specials-price-old">{formatCurrency(offer.originalPrice)}</span>
                  <span className="marketing-specials-price">{formatCurrency(offer.price)}</span>
                </div>
                <div className="marketing-specials-meta">Orden de visualización: #{offer.order}</div>
                <div className="marketing-specials-meta">Vigencia: {formatDates(offer.start, offer.end)}</div>
              </Card>
            </Col>
          ))}
        </Row>

        <Button
          type="primary"
          size="large"
          icon={<PlusOutlined />}
          className="marketing-specials-fab"
          onClick={openNew}
        >
          Nueva Oferta
        </Button>

        <Modal
          open={modalOpen}
          title={editing || editingGroupId ? 'Editar oferta' : 'Nueva oferta'}
          onCancel={() => setModalOpen(false)}
          onOk={() => form.submit()}
          okText={editing || editingGroupId ? 'Guardar cambios' : 'Crear oferta'}
          confirmLoading={saving}
          centered
          width={900}
          className="marketing-specials-modal"
        >
          <div className="marketing-specials-subtitle">{modalSubtitle}</div>
          <Form layout="vertical" form={form} onFinish={onFinish}>
            <Form.Item
              label="Sección donde se muestra"
              name="section"
              rules={[{ required: true, message: 'Selecciona una seccion' }]}
            >
              <Select>
                <Option value="offers">Ofertas</Option>
                <Option value="specials">Especiales</Option>
                <Option value="top3">Productos Top (Top 3)</Option>
              </Select>
            </Form.Item>

            {sectionValue === 'top3' && (
              <>
                <div className="marketing-specials-tip">
                  <strong>Instrucciones:</strong> Anade hasta 3 productos mas vendidos. Puedes ordenarlos usando
                  las flechas arriba/abajo para cambiar su posicion en el ranking.
                </div>

                <Form.List name="topProducts">
                  {(fields, { add, remove, move }) => (
                    <>
                      <div className="marketing-specials-add">
                        <Button
                          type="dashed"
                          onClick={() => fields.length < 3 && add()}
                          icon={<PlusOutlined />}
                          block
                        >
                          Agregar Producto ({fields.length}/3)
                        </Button>
                      </div>

                      {fields.map((field, index) => (
                        <div key={field.key} className="marketing-specials-product">
                          <div className="marketing-specials-product-header">
                            <div className="marketing-specials-product-index">{index + 1}</div>
                            <div className="marketing-specials-product-title">Producto #{index + 1}</div>
                            <div className="marketing-specials-product-actions">
                              <Button
                                type="text"
                                icon={<ArrowUpOutlined />}
                                disabled={index === 0}
                                onClick={() => move(index, index - 1)}
                              />
                              <Button
                                type="text"
                                icon={<ArrowDownOutlined />}
                                disabled={index === fields.length - 1}
                                onClick={() => move(index, index + 1)}
                              />
                              <Button
                                type="text"
                                danger
                                icon={<DeleteOutlined />}
                                onClick={() => remove(field.name)}
                              />
                            </div>
                          </div>

                          <Row gutter={[12, 12]}>
                            <Col span={16}>
                              <Form.Item
                                label="Título"
                                name={[field.name, 'title']}
                                rules={[{ required: true, message: 'Ingresa el título' }]}
                              >
                                <Input placeholder="Nombre del producto" />
                              </Form.Item>
                            </Col>
                            <Col span={8}>
                              <Form.Item
                                label="Categoria"
                                name={[field.name, 'category']}
                                rules={[{ required: true, message: 'Selecciona una categoría' }]}
                              >
                                <Select placeholder="Seleccionar">
                                  {categories.map((cat) => (
                                    <Option key={cat} value={cat}>
                                      {cat}
                                    </Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            </Col>
                            <Col span={24}>
                              <Form.Item
                                label="Descripción"
                                name={[field.name, 'description']}
                                rules={[{ required: true, message: 'Ingresa la descripción' }]}
                              >
                                <Input.TextArea rows={3} placeholder="Descripción del producto..." />
                              </Form.Item>
                            </Col>
                            <Col span={8}>
                              <Form.Item
                                label="Descuento (%)"
                                name={[field.name, 'discountPct']}
                                rules={[{ required: true, message: 'Ingresa el descuento' }]}
                              >
                                <InputNumber min={0} max={90} style={{ width: '100%' }} />
                              </Form.Item>
                            </Col>
                            <Col span={8}>
                              <Form.Item
                                label="Precio original"
                                name={[field.name, 'originalPrice']}
                                rules={[{ required: true, message: 'Ingresa el precio original' }]}
                              >
                                <InputNumber min={0} style={{ width: '100%' }} />
                              </Form.Item>
                            </Col>
                            <Col span={8}>
                              <Form.Item
                                label="Precio final"
                                name={[field.name, 'price']}
                                rules={[{ required: true, message: 'Ingresa el precio final' }]}
                              >
                                <InputNumber min={0} style={{ width: '100%' }} />
                              </Form.Item>
                            </Col>
                            <Col span={12}>
                              <Form.Item
                                label="Vigencia - Desde"
                                name={[field.name, 'start']}
                                rules={[{ required: true, message: 'Selecciona la fecha' }]}
                              >
                                <DatePicker style={{ width: '100%' }} format="DD/MM/YYYY" />
                              </Form.Item>
                            </Col>
                            <Col span={12}>
                              <Form.Item
                                label="Vigencia - Hasta"
                                name={[field.name, 'end']}
                                rules={[{ required: true, message: 'Selecciona la fecha' }]}
                              >
                                <DatePicker style={{ width: '100%' }} format="DD/MM/YYYY" />
                              </Form.Item>
                            </Col>
                            <Col span={24}>
                              <Form.Item
                                label="Imagen del producto"
                                name={[field.name, 'image']}
                                valuePropName="fileList"
                                getValueFromEvent={normalizeUpload}
                                rules={[
                                  {
                                    validator: (_, value) =>
                                      value && value.length > 0
                                        ? Promise.resolve()
                                        : Promise.reject(new Error('Selecciona una imagen'))
                                  }
                                ]}
                              >
                                <Dragger
                                  className="marketing-specials-dragger"
                                  beforeUpload={() => false}
                                  maxCount={1}
                                  accept="image/*"
                                >
                                  <InboxOutlined />
                                  <div>Haz clic para seleccionar una imagen</div>
                                  <small>PNG, JPG, GIF hasta 10MB</small>
                                </Dragger>
                              </Form.Item>
                            </Col>
                          </Row>
                        </div>
                      ))}
                    </>
                  )}
                </Form.List>
              </>
            )}

            {sectionValue !== 'top3' && (
              <Row gutter={[12, 12]}>
                <Col span={24}>
                  <Form.Item
                    label="Título"
                    name="title"
                    rules={[{ required: true, message: 'Ingresa el título' }]}
                  >
                    <Input placeholder="Nombre del producto" />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    label="Descripción"
                    name="description"
                    rules={[{ required: true, message: 'Ingresa la descripcion' }]}
                  >
                    <Input.TextArea rows={3} placeholder="Descripción del producto..." />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Categoría"
                    name="category"
                    rules={[{ required: true, message: 'Selecciona una categoría' }]}
                  >
                    <Select placeholder="Seleccionar categoría">
                      {categories.map((cat) => (
                        <Option key={cat} value={cat}>
                          {cat}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Descuento (%)"
                    name="discountPct"
                    rules={[{ required: true, message: 'Ingresa el descuento' }]}
                  >
                    <InputNumber min={0} max={90} style={{ width: '100%' }} />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Precio original"
                    name="originalPrice"
                    rules={[{ required: true, message: 'Ingresa el precio original' }]}
                  >
                    <InputNumber min={0} style={{ width: '100%' }} />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Precio final"
                    name="price"
                    rules={[{ required: true, message: 'Ingresa el precio final' }]}
                  >
                    <InputNumber min={0} style={{ width: '100%' }} />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Vigencia - Desde"
                    name="start"
                    rules={[{ required: true, message: 'Selecciona la fecha' }]}
                  >
                    <DatePicker style={{ width: '100%' }} format="DD/MM/YYYY" />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Vigencia - Hasta"
                    name="end"
                    rules={[{ required: true, message: 'Selecciona la fecha' }]}
                  >
                    <DatePicker style={{ width: '100%' }} format="DD/MM/YYYY" />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    label="Imagen del producto"
                    name="image"
                    valuePropName="fileList"
                    getValueFromEvent={normalizeUpload}
                    rules={[
                      {
                        validator: (_, value) =>
                          value && value.length > 0
                            ? Promise.resolve()
                            : Promise.reject(new Error('Selecciona una imagen'))
                      }
                    ]}
                  >
                    <Dragger
                      className="marketing-specials-dragger"
                      beforeUpload={() => false}
                      maxCount={1}
                      accept="image/*"
                    >
                      <InboxOutlined />
                      <div>Haz clic para seleccionar una imagen</div>
                      <small>PNG, JPG, GIF hasta 10MB</small>
                    </Dragger>
                  </Form.Item>
                </Col>
              </Row>
            )}
          </Form>
        </Modal>
      </Content>
    </LayoutPage>
  )
}
